import { FC } from 'react';

import { LucideIcon } from 'lucide-react';

import { cn } from '../../../utils';

interface Props {
    readonly icon: LucideIcon;
    readonly className?: string;
    readonly containerClassName?: string;
}

export const FilterGlyphIcon: FC<Props> = ({
    icon: Icon,
    className,
    containerClassName,
}) => (
    <span
        aria-hidden="true"
        className={cn(
            'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full border bg-muted text-foreground shadow-sm',
            containerClassName,
            className,
        )}
    >
        <Icon className="h-4 w-4" strokeWidth={2.25} />
    </span>
);
